/**
 * Detection of internal/test users for analytics filtering.
 *
 * Mirrors the email/domain clauses of PostHog cohort 111116
 * ("Internal / Test users"). Persons identified with one of these emails get
 * `$internal_or_test_user: true` set on their profile so they're excluded from
 * dashboards immediately — without waiting for the cohort-membership table to
 * recalculate.
 *
 * The cohort also has `$host icontains .vercel.app` / `.dev` clauses, but those
 * are auto-set by the PostHog SDK from `window.location.host`, so no code-side
 * mirroring is needed for them.
 */

import { isInternalEmail } from "@oekopunktemarkt/crm";
export { isInternalEmail } from "@oekopunktemarkt/crm";

/**
 * Returns the input properties enriched with `$internal_or_test_user: true`
 * when the email indicates an internal/test user. Pass-through otherwise.
 */
export function withInternalUserFlag(
  properties: Record<string, unknown> | undefined
): Record<string, unknown> | undefined {
  const email = typeof properties?.email === "string" ? properties.email : null;
  if (!email || !isInternalEmail(email)) return properties;
  return { ...properties, $internal_or_test_user: true };
}
